
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 82.51 33.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.38 12.38h5.5v2.75h-5.5z"}}),_c('path',{attrs:{"d":"M81.33 8.26L72 6.93A47 47 0 0047.54 0h-1.63a46.81 46.81 0 00-22.32 5.69l-4.71 2.57a32.54 32.54 0 00-15.73 4.27A6.27 6.27 0 000 18v8.17a1.37 1.37 0 001.38 1.33H6a8.22 8.22 0 0015.52 0h36.73a8.21 8.21 0 0015.51 0h.5a1.29 1.29 0 00.51-.1l4.45-1.78a5.21 5.21 0 003.29-4.86V9.63a1.38 1.38 0 00-1.18-1.37zM19.14 25.85a5.51 5.51 0 11.11-1.1 5.78 5.78 0 01-.11 1.1zM44 24.75H22a8.25 8.25 0 00-16.5 0H2.75V18a3.53 3.53 0 011.77-3.05A29.73 29.73 0 0119.25 11H44zm0-16.5H24.65l.26-.14A43.92 43.92 0 0144 2.81zm2.75-5.5h.78a43.5 43.5 0 0116.18 3.1l-2.4 2.4H46.75zm24.65 23.1a5.51 5.51 0 11.11-1.1 5.78 5.78 0 01-.11 1.1zm8.36-13.47v8.38a2.47 2.47 0 01-1.56 2.3l-3.94 1.59v-.38-.41c0-.13 0-.28-.07-.42s0-.27-.06-.4-.07-.26-.1-.39-.07-.26-.11-.39-.09-.25-.14-.38-.09-.25-.13-.38-.12-.23-.17-.35l-.18-.36c-.07-.12-.14-.22-.2-.33a3.37 3.37 0 00-.22-.35l-.23-.3-.24-.33a3.58 3.58 0 00-.26-.28c-.09-.08-.18-.2-.28-.29a2.27 2.27 0 00-.28-.26l-.3-.28a3.09 3.09 0 00-.31-.23c-.11-.08-.21-.17-.32-.24l-.36-.21a2.8 2.8 0 00-.32-.2l-.38-.18a2.6 2.6 0 00-.34-.16L68.8 17l-.35-.12c-.15-.05-.31-.08-.47-.12l-.31-.08a4.67 4.67 0 00-.52-.08l-.3-.05h-.84a8.26 8.26 0 00-8.25 8.25h-11V11h15.12a1.34 1.34 0 001-.4L66.42 7a42.88 42.88 0 014.36 2.39 1.4 1.4 0 00.53.19l8.45 1.21z"}})])
          )
        }
      }
    